var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAngleRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M104.142 254.142c-7.81 7.81-20.474 7.81-28.284 0-7.21-7.21-7.764-18.554-1.664-26.4l1.664-1.884L161.7 140 75.858 54.142c-7.21-7.21-7.764-18.554-1.664-26.4l1.664-1.884c7.21-7.21 18.554-7.764 26.4-1.664l1.884 1.664 100 100c7.21 7.21 7.764 18.554 1.664 26.4l-1.664 1.884z"
})));
export default SvgAngleRight;